import styled from 'styled-components';

export const PodcastContainer = styled.div`
  height: 45px;
  width: 100%;
`;
